<template>
  <div>
    <b-form-group id="input-group-10" label="Responsable" label-for="input-10">
      <b-form-select
        @change="listMotiveResponsible"
        id="input-10"
        v-model="selectedResponsible"
        :options="filteredResponsibles"
        required
      >
        <b-form-select-option :value="null"
          >Seleccione una opción
        </b-form-select-option>
      </b-form-select>
    </b-form-group>
    <template v-if="selectedResponsible">
      <b-row>
        <b-col cols="12">
          <b-form-group id="input-group-11" label="Motivo" label-for="input-11">
            <b-form-select
              id="input-11"
              v-model="motiveSelected"
              :options="motivesResponsibles"
              required
            >
              <b-form-select-option :value="null"
                >Seleccione una opción
              </b-form-select-option>
            </b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-form-group
            id="input-group-12"
            label="Observaciones"
            label-for="input-12"
          >
            <b-form-input
              id="input-12"
              v-model="form.observation"
              placeholder="Ingrese aquí sus observaciones"
              required
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="6">
          <label>Fecha Estimada</label>

          <calendar v-model="form.estimatedDate" />
        </b-col>
        <b-col cols="6">
          <label>Turno</label>
          <b-form-select
            v-model="turnSelected"
            :options="turn"
            required
          ></b-form-select>
        </b-col>
      </b-row>
    </template>

    <b-row>
      <b-col cols="12" class="text-center padding-two-top">
        <b-button :disabled="checkIsEnabled" @click="earlyReprogramarOS" class="btn-orange">
          <font-awesome-icon icon="check-circle" /> Reprogramar
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import axios from "axios";
import { mapState } from "vuex";
import Calendar from "./Calendar.vue";
export default {
  components: { Calendar },
  name: "ReprogramarAnticOs",
  props: ["detailId"],
  data() {
    return {
      turnSelected: null,
      form: { estimatedDate: "", observation: "" },
      vouchers: [{ details: [] }],
      selectedOptionPayment: "",
      motiveSelected: null,
      motivesResponsibles: [],
      responsibles: [],
      selectedResponsible: null,
      options: [
        { text: "Validar pago", value: "A" },
        { text: "Exonerar pago", value: "B" },
      ],
      selectedStore: null,
      paymentValidate: { date: "", caja: "", nv: "" },
      optionStores: [],
      turn: [
        { value: "MORNING", text: "Mañana" },
        { value: "ALL_DAY", text: "Todo el día" },
        { value: "AFTERNOON", text: "Tarde" },
      ],
      valuesResponseReproAntic: { show: true, message: "", hasError: false },
    };
  },
  computed: {
    checkIsEnabled() {
      if (this.form.estimatedDate && this.turnSelected&&this.motiveSelected) return false;
      else return true;
    },
    filteredResponsibles() {
      return this.responsibles.filter((entry) => {
        return (
          entry.value != 5 &&
          entry.value != 6 &&
          entry.value != 8 &&
          entry.value != 9 &&
          entry.value != 10
        );
      });
    },
    ...mapState("module", ["username","token"]),
  },
  created() {
    this.listResponsible();
    //this.getStores();
  },
  methods: {
    getStores() {
      axios
        .get(process.env.VUE_APP_ENDPOINT_STORE + "/stores?limit=1000&page=1",{
          headers: {
              "Content-type": "application/json",
              "Authorization": "Bearer "+ this.token
            }
        })
        .then((response) => {
          const data = response.data.map((row) => {
            return {
              value: row.code,
              text: row.code + "-" + row.name,
            };
          });
          this.optionStores = data;
        })
        .catch((error) => console.log(error));
    },
    async searchVouchers() {
      try {
        this.$store.commit("SET_LOADING", true);
        let response = await axios.get(
          process.env.VUE_APP_PAYMENT_REF +
            "/voucher-ref?date=" +
            this.paymentValidate.date +
            "&pos=" +
            this.paymentValidate.caja +
            "&sequence=" +
            this.paymentValidate.sequence +
            "&store=" +
            this.selectedStore,
            {
              headers: {
                  "Content-type": "application/json",
                  "Authorization": "Bearer "+ this.token
                }
            }
        );

        this.vouchers = response.data;
      } catch (error) {
        console.log(error);
      } finally {
        this.$store.commit("SET_LOADING", false);
      }
    },
    async listResponsible() {
      try {
        let response = await axios.get(
          process.env.VUE_APP_ORDERS_CORE_BASE + "/responsibles?limit=50&page=1"
        );
        const data = response.data.map((row) => {
          return {
            value: row.id,
            text: row.responsible,
          };
        });
        this.responsibles = data;
        console.log(response);
      } catch (error) {
        console.log(error);
      }
    },
    async earlyReprogramarOS() {
      try {
        this.$store.commit("SET_LOADING", true);
        await axios.post(
          process.env.VUE_APP_ORDER_BUSINESS_BASE + "/earlyreschedulings",
          {
            childId: this.detailId,
            user: this.username,
            date: this.form.estimatedDate,
            turn: this.turnSelected,
            motiveId: this.motiveSelected,
            observations: this.form.observation,
          }, // the data to post
          {
            headers: {
              "Content-type": "application/json",
              "client_id":process.env.VUE_APP_CLIENT_ID_REPRO,
              "access_token":process.env.VUE_APP_ACCESS_TOKEN_REPRO
            },
          }
        );

        this.valuesResponseReproAntic.message = "Reprogramación exitosa";
      } catch (error) {
        console.log(error);
        this.valuesResponseReproAntic.hasError = true;
        this.valuesResponseReproAntic.message = error.response.data.message;
      } finally {
        this.$bvModal.hide("modal-reprogramar-antic");
        this.$emit("setResponse", this.valuesResponseReproAntic);
        this.$store.commit("SET_LOADING", false);
      }
    },
    async listMotiveResponsible() {
      if (this.motiveSelected) this.motiveSelected = null;
      this.selectedOptionPayment = "";
      try {
        this.$store.commit("SET_LOADING", true);
        let response = await axios.get(
          process.env.VUE_APP_ORDERS_CORE_BASE +
            "/responsibles/" +
            this.selectedResponsible +
            "/motives"
        );
        const data = response.data.map((row) => {
          return {
            value: row.id,
            text: row.description,
          };
        });
        this.motivesResponsibles = data;
        console.log(response);
      } catch (error) {
        console.log(error);
      } finally {
        this.$store.commit("SET_LOADING", false);
      }
    },
  },
};
</script>
<style scoped></style>
